export enum OpenComponent {
  HOME = 0,
  CREATE_USER = 1,
  UPDATE_USER = 2,
  VIEW_USER = 3,
  ASSIGN_MID = 4,
}

export enum UserManagementFilterMode {
  PAYMENT_LINK_MODE = 1,
  APPROVE_ENTITY_MODE = 2,
}
